module.exports = __webpack_public_path__ + "img/paying@3x.902e84ec.png";